module.exports = __webpack_public_path__ + "img/ipad_en.87dbd43.jpg";